<template>
  <LoginWrapper>
    <div class="box">
      <div class="box_title">
        <h2>{{ $t('views.auth.login.passwordchange.8919') }}</h2>
        <p class="guide_txt">
          {{ $t('views.auth.login.passwordchange.4121') }}
        </p>
      </div>

      <ul class="form_wrap">
        <li class="input_wrap correct">
          <p class="sub_title">
            {{ $t('views.auth.login.passwordchange.2681') }}
          </p>
          <label for="newPassword" class="hidden">새 ㄹㄹㄹㄹ비밀번호</label>
          <input
            id="newPassword"
            v-model="newPassword"
            class="input_t"
            type="password"
            maxlength="15"
            :placeholder="$t('views.auth.login.passwordchange.4901')"
          />
          <!-- TODO: Add check for whether password is acceptable and bind class below accordingly -->
          <!-- 오류메세지 노출시 .txt_message display:block, 비노출시 display:none -->
          <!-- <p class="txt_message"><span>{{ $t('views.auth.login.passwordchange.6043') }}</span></p> -->
          <!-- <p class="txt_message"><span>{{ $t('views.auth.login.passwordchange.8260') }}</span></p> -->
        </li>
        <li class="input_wrap" :class="{ incorrect: !passwordMatch }">
          <p class="sub_title">
            {{ $t('views.auth.login.passwordchange.2667') }}
          </p>
          <label for="passwordCheck" class="hidden">비밀번호 확인</label>
          <input
            id="passwordCheck"
            v-model="passwordCheck"
            class="input_t"
            type="password"
            maxlength="15"
            :placeholder="$t('views.auth.login.passwordchange.934')"
          />
          <!-- <p class="txt_message"><span>{{ $t('views.auth.login.passwordchange.5898') }}</span></p> -->
          <p v-show="!passwordMatch" class="txt_message">
            <span>{{ $t('views.auth.login.passwordchange.7347') }}</span>
          </p>
        </li>
      </ul>
      <div class="btn_wrap mt50">
        <button
          class="box_btn"
          :class="{ dull: !newPasswordValid }"
          @click="updatePassword"
        >
          <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
        </button>
      </div>
    </div>

    <!-- ERROR MODAL START -->
    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleErrorModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner text-center">
              <p>
                {{ errorMessage }}
              </p>
              <div v-if="showOkButton" class="btn_wrap mt50">
                <router-link :to="{ name: 'login' }">
                  <button class="box_btn">
                    <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <!-- ERROR MODAL END -->
    </transition>
  </LoginWrapper>
</template>

<script>
import LoginWrapper from '@/components/auth/LoginWrapper.vue'
import { ACCOUNT_UPDATE_PASSWORD_MAIL } from '@/store/types'

export default {
  name: 'PasswordChange',

  components: { LoginWrapper },
  data() {
    return {
      newPassword: '',
      passwordCheck: '',
      showErrorModal: false,
      showOkButton: false,
      errorMessage: ''
    }
  },
  computed: {
    passwordMatch() {
      if (!this.newPassword || !this.passwordCheck) {
        return true
      }
      if (this.newPassword === this.passwordCheck) {
        return true
      }
      return false
    },
    newPasswordValid() {
      if (!this.newPassword || !this.passwordCheck) {
        return false
      }
      if (this.passwordMatch) {
        return true
      }
      return false
    }
  },
  methods: {
    toggleErrorModal(errorMessage) {
      this.errorMessage = errorMessage || 'Error'
      this.showErrorModal = !this.showErrorModal
    },
    resetPasswordFields() {
      this.newPassword = ''
      this.passwordCheck = ''
    },
    async updatePassword() {
      if (!this.newPasswordValid) {
        return
      }
      try {
        const updateHash = this.$route.params.updateHash
        const newPassword = 'this.newPassword'

        this.$store.dispatch(ACCOUNT_UPDATE_PASSWORD_MAIL, {
          newPassword,
          updateHash
        })

        this.showOkButton = true
        this.toggleErrorModal(
          '정상처리 되었습니다. 로그인 페이지로 이동합니다.'
        )
        this.resetPasswordFields()
      } catch (err) {
        //Error: 사용할 수 없는 비밀번호 입니다.
        this.toggleErrorModal(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chk_round .text_label input:checked + em:after {
  margin-top: 4px;
  margin-left: 1px;
  width: 12px !important;
  height: 12px !important;
}
</style>
